import { createAction } from '@reduxjs/toolkit';
import { type ShippingMethod } from '../../types/Shipping';

export const setGooglePayButtonVisibility = createAction<'visible' | 'hidden', 'SET_GOOGLE_PAY_BUTTON_VISIBILITY'>(
  'SET_GOOGLE_PAY_BUTTON_VISIBILITY',
);

export const setGooglePayPaymentDataShippingMethods = createAction<
  ShippingMethod[] | undefined,
  'SET_GOOGLE_PAY_PAYMENT_DATA_SHIPPING_OPTIONS'
>('SET_GOOGLE_PAY_PAYMENT_DATA_SHIPPING_OPTIONS');
